/** Normalise Israeli / international numbers to E.164 for comparison and wa.me links. Returns null if not a phone. */
export function toE164(raw?: string | null): string | null {
  if (!raw) return null;
  let d = raw.replace(/[^\d+]/g, '');
  if (!d) return null;
  if (d.startsWith('+')) d = d.slice(1);
  else if (d.startsWith('00')) d = d.slice(2);
  else if (d.startsWith('0')) d = '972' + d.slice(1);
  else if (d.length <= 9) d = '972' + d; // 5xxxxxxxx without the leading zero
  if (d.length < 8 || d.length > 15) return null;
  return '+' + d;
}

/** How a person dials it here: Israeli numbers in local form (0545850626), anything else as E.164. */
export function displayPhone(raw?: string | null): string | null {
  if (!raw) return null;
  const e = toE164(raw);
  if (!e) return raw.trim() || null;
  return e.startsWith('+972') ? '0' + e.slice(4) : e;
}

/** A WhatsApp chat with this number; `text` pre-fills the message box (the person can still edit it before sending). */
export function waLink(raw?: string | null, text?: string | null): string | null {
  const e = toE164(raw);
  if (!e) return null;
  const t = text?.trim();
  return `https://wa.me/${e.slice(1)}${t ? `?text=${encodeURIComponent(t)}` : ''}`;
}

export function telLink(raw?: string | null): string | null {
  const e = toE164(raw);
  return e ? `tel:${e}` : null;
}
